import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-notif-intervention-annulee',
  templateUrl: './notif-intervention-annulee.component.html',
  styleUrls: ['./notif-intervention-annulee.component.scss'],
})
export class NotifInterventionAnnuleeComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  nom_intervention = '';
  constructor(private navParams: NavParams, private modalController: ModalController) {
    this.nom_intervention = this.navParams.get('nom');
  }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true
    });
  }
}
